import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppLayout from "@/components/AppLayout";
import { ClientSidebar } from "@/components/sidebars";
import { useAuth } from "@/lib/auth";
import { apiClient } from "@/lib/api";

export default function ClientDashboard() {
  const { user, refresh } = useAuth();
  const [solicitudes, setSolicitudes] = useState([]);
  const [porEvaluar, setPorEvaluar] = useState([]);

  useEffect(() => {
    refresh();
    apiClient.get("/solicitudes").then(({ data }) => setSolicitudes(data)).catch(() => {});
    apiClient.get("/me/solicitudes-por-evaluar").then(({ data }) => setPorEvaluar(data)).catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const statusBadge = user?.membership_status === "active" ? "active" : "pending";
  const beneficiariosCount = user?.beneficiarios?.length || 0;

  return (
    <AppLayout sidebar={ClientSidebar}>
      <header className="app-header">
        <h1>Hola, {user?.nombre?.split(" ")[0] || "tu Ángel está aquí"}</h1>
        <p className="text-muted">Gestiona tu membresía y solicita servicio para tu familia en México.</p>
      </header>

      {porEvaluar.length > 0 && (
        <div
          data-testid="banner-por-evaluar"
          style={{
            background: "linear-gradient(90deg, #FEF3C7 0%, #FDE68A 100%)",
            border: "1px solid #F59E0B",
            borderRadius: 12,
            padding: "16px 20px",
            marginBottom: 20,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 16,
            flexWrap: "wrap",
          }}
        >
          <div>
            <strong style={{ color: "#92400E", fontSize: 15 }}>
              🙏 Tienes {porEvaluar.length} servicio{porEvaluar.length > 1 ? "s" : ""} por evaluar
            </strong>
            <div style={{ color: "#78350F", fontSize: 13, marginTop: 2 }}>
              Tu opinión nos ayuda a mejorar. Toma menos de 1 minuto.
            </div>
          </div>
          <Link
            to={`/cuenta/historial?evaluar=${porEvaluar[0].id}`}
            style={{ background: "#B45309", color: "white", padding: "10px 18px", borderRadius: 8, textDecoration: "none", fontWeight: 700, fontSize: 14 }}
            data-testid="banner-evaluar-cta"
          >
            Evaluar ahora →
          </Link>
        </div>
      )}

      <section className="cards-row">
        <div className={`stat-card ${statusBadge === "active" ? "stat-ok" : "stat-warn"}`} data-testid="stat-membership">
          <span className="stat-label">Membresía</span>
          <strong className="stat-value">
            {statusBadge === "active" ? "Activa" : "Pendiente"}
          </strong>
          <small>{user?.plan ? `Plan ${user.plan}` : "Sin plan"}</small>
        </div>
        <div className="stat-card" data-testid="stat-beneficiarios">
          <span className="stat-label">Beneficiarios</span>
          <strong className="stat-value">{beneficiariosCount}</strong>
          <Link to="/cuenta/beneficiarios" className="stat-link">Gestionar →</Link>
        </div>
        <div className="stat-card" data-testid="stat-solicitudes">
          <span className="stat-label">Solicitudes</span>
          <strong className="stat-value">{solicitudes.length}</strong>
          <Link to="/cuenta/historial" className="stat-link">Ver historial →</Link>
        </div>
        <div className="stat-card" data-testid="stat-salud" style={{ borderColor: user?.anura_addon_active ? "#DC2626" : undefined, background: user?.anura_addon_active ? "#FEF2F2" : undefined }}>
          <span className="stat-label"><i className="fas fa-heart-pulse" style={{ color: "#DC2626" }} /> Chequeo de salud</span>
          <strong className="stat-value">{user?.anura_addon_active ? "Activo" : "—"}</strong>
          <Link to="/cuenta/salud" className="stat-link">{user?.anura_addon_active ? "Hacer chequeo →" : "Conocer más →"}</Link>
        </div>
      </section>

      {statusBadge !== "active" && (
        <div className="alert-card" data-testid="alert-activar">
          <i className="fas fa-info-circle" />
          <div>
            <strong>Tu membresía no está activa.</strong>
            <p>{beneficiariosCount === 0 ? "Agrega beneficiarios y elige un plan para activar la servicio." : "Elige un plan para activar la servicio."}</p>
          </div>
          <Link to="/cuenta/onboarding" className="btn btn-primary" data-testid="continue-setup">
            Continuar configuración
          </Link>
        </div>
      )}

      <section className="panel">
        <h2>Solicitudes recientes</h2>
        {solicitudes.length === 0 ? (
          <p className="text-muted">Aún no hay solicitudes.</p>
        ) : (
          <ul className="sol-list">
            {solicitudes.slice(0, 5).map((s) => (
              <li key={s.id} data-testid={`sol-${s.id}`}>
                <span className={`sol-pill sol-${s.status}`}>{s.status}</span>
                <strong>{s.tipo.toUpperCase()}</strong>
                <span className="text-muted">{s.beneficiario?.nombre}</span>
                <small>{new Date(s.created_at).toLocaleString("es-MX")}</small>
              </li>
            ))}
          </ul>
        )}
      </section>
    </AppLayout>
  );
}
